import styled from 'styled-components';

import { media } from '@simplywallst/ui-core';

export const Table = styled('table')`
  ${({ theme }) => theme.typography.smallStrong}
  width: 100%;
  border-spacing: 0;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    margin-top: 0;
  `}
  th {
    text-align: left;
    ${({ theme }) => theme.typography.tinyStrong};
  }
  td {
    height: 38px;
    padding-bottom: ${({ theme }) => theme.x1spacePx}px;
    vertical-align: bottom;
    border-bottom: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.1)};
    &:nth-child(2) {
      text-align: right;
    }
  }
  caption {
    ${({ theme }) => theme.typography.tiny}
    opacity: 0.5;
    padding-top: ${({ theme }) => theme.x1spacePx}px;
    caption-side: bottom;
    text-align: left;
  }
`;
